import { FC, useState } from 'react';

import { HeaderText } from '@/components';
import { HeaderSize } from '@/components/ui/HeaderText';

import { TypeSubEngineInstallment } from '@/lib/api/subscriptionManager/types';

import { TypeAccountERCTranslations } from '@/utils/translations/types/TypeAccountERCTranslations';

import { Box } from '../Box';

import { TypeERCBox } from '../../utils';

export type NextOrderProps = {
  t: TypeAccountERCTranslations;
  nextOrder: TypeERCBox;
};

const NextOrder: FC<NextOrderProps> = ({ t, nextOrder }) => {
  const [installmentData, setInstallmentData] = useState(
    nextOrder.installmentData as TypeSubEngineInstallment,
  );

  return (
    <>
      <div className="grid gap-y-2 md:gap-y-4">
        <HeaderText
          classes="text-h-x3 md:text-h-x2 px-6 xl:px-0"
          omitSizeString
          size={HeaderSize.H2}
          text={t.nextOrder}
        />

        {nextOrder.orderData && (
          <Box
            t={t}
            orderData={nextOrder.orderData}
            installmentData={installmentData}
            setInstallmentData={setInstallmentData}
            productData={nextOrder.productData}
            paymentMethodData={nextOrder.paymentMethodData}
            isNextOrder
          />
        )}
      </div>
    </>
  );
};

export default NextOrder;
